import * as React from "react"
import Svg, { SvgProps, Circle, Path } from "react-native-svg"
const SvgComponent = (props: SvgProps) => (
  <Svg
    xmlns="http://www.w3.org/2000/svg"
    width={48}
    height={48}
    fill="none"
    {...props}
  >
    <Circle
      cx={23.689}
      cy={24.001}
      r={23.294}
      stroke="#FDFBF9"
      strokeWidth={0.79}
    />
    <Path
      fill="#FDFBF9"
      fillRule="evenodd"
      d="M25.659 14.76a9.46 9.46 0 0 0 .408 2.53 9.497 9.497 0 0 0 6.294 6.293l.055.017c.86.257 1.771.395 2.715.395-.944 0-1.855.138-2.715.395l-.055.016a9.497 9.497 0 0 0-6.294 6.294 9.459 9.459 0 0 0-.409 2.53v-3.722c.922-2.2 2.587-4.01 4.682-5.118h-4.681v-.79h4.68a10.304 10.304 0 0 1-4.68-5.118V14.76Z"
      clipRule="evenodd"
    />
    <Path stroke="#FDFBF9" strokeWidth={0.79} d="M31.578 23.996h-18.95" />
  </Svg>
)
export default SvgComponent
